import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter as Router } from 'react-router-dom'
import './index.css'
import App from './App'
import { ThemeProvider } from 'rimble-ui'

import { appTheme } from './utils/appTheme'

import reportWebVitals from './utils/reportWebVitals'

ReactDOM.render(
  <React.StrictMode>
    <Router>
      <ThemeProvider theme={appTheme}>
        <App />
      </ThemeProvider>
    </Router>
  </React.StrictMode>,
  document.getElementById('app')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
